/*
	Small shared helpers for the Tienda screens and the components/kits modals (no React, no imports, so both
	src/navigation/v2/store/kits/shared.tsx and the components can use them without circular imports).
*/

/**
 * Font size for text inputs and selects. iOS zooms the page when a focused field has less than 16 px,
 * so touch screens get 16 px; computers keep the compact 13 px.
 */
export const isTouchScreen = (): boolean => {
	try {
		return typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia("(pointer: coarse)").matches;
	} catch (error) {
		return false;
	}
};

export const FIELD_FONT: string = isTouchScreen() ? "16px" : "13px";

/** Real reason of a failed request (first validation error, or the message), never a generic text when the server said why. */
export const requestErrorText = (requestError: any, fallback: string): string => {
	const payload = requestError?.response?.data;
	const first = payload?.errors ? Object.values(payload.errors)[0] : null;
	if (first) return String(Array.isArray(first) ? first[0] : first);
	if (payload?.message) return String(payload.message);
	if (requestError?.response === undefined && requestError?.message) return fallback + " (sin conexión con el servidor)";
	return fallback;
};

/**
 * Decimal typed by a person: accepts "1500", "1,500.50", "1500,5" and "12,5". Returns null when empty and NaN when it is not a number.
 * A single comma with 1-2 digits after it is a decimal comma; otherwise commas are thousands separators.
 */
export const parseDecimal = (text: string): number | null => {
	const raw = (text || "").trim().replace(/\s/g, "");
	if (raw === "") return null;
	let normalized = raw;
	if (raw.includes(",") && !raw.includes(".") && /^-?\d+,\d{1,2}$/.test(raw)) normalized = raw.replace(",", ".");
	else normalized = raw.replace(/,/g, "");
	if (!/^-?\d*\.?\d+$/.test(normalized) && !/^-?\d+\.$/.test(normalized)) return NaN;
	return Number(normalized);
};

/** Local calendar date YYYY-MM-DD (toISOString is UTC: after 6 pm in México/Honduras it is already tomorrow). */
export const localIsoDate = (date: Date): string =>
	date.getFullYear() + "-" + String(date.getMonth() + 1).padStart(2, "0") + "-" + String(date.getDate()).padStart(2, "0");
